import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/imports/history')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('orders:write')) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/imports/pages/import-history-page')),
});
